import React, { Component } from "react";

import UserImage from "../../user_image";
import ListMedia from "./list_media";

import ActionAnswer from "./answer/action_answer";
import { Link } from "react-router-dom";

import EditAnswer from "./answer/edit_answer";

class ListAnswerRow extends Component {
  state = { edit: false };
  render() {
    return (
      <div style={{ position: "relative" }}>
        {this.renderRow()}
        {this.renderMedia()}
        <ActionAnswer
          answer={this.props.answer}
          removeAnswer={this.props.removeAnswer}
          editQuestion={this.editQuestion}
        />
      </div>
    );
  }

  renderRow() {
    if (this.props.answer.answer_type === "text") {
      return (
        <div className="row max_width_500 pt-4">
          <div className="width_image_question" style={{ alignItems: "unset" }}>
            <Link
              to={"/users/" + this.props.answer.user.username}
              style={{ flex: 1 }}
            >
              <UserImage
                user={this.props.answer.user}
                bottomImage={false}
                link={false}
              />
            </Link>
          </div>
          <div
            className="width_text_question "
            style={{ flexDirection: "column", alignItems: "unset" }}
          >
            <Link to={"/users/" + this.props.answer.user.username}>
              <label className="name" style={{ marginTop: "2.5px" }}>
                {this.props.answer.user.first_name}{" "}
                {this.props.answer.user.last_name}
              </label>
            </Link>
            {this.renderAnswer()}
          </div>
        </div>
      );
    } else {
      return (
        <React.Fragment>
          <div className="row max_width_500 pt-2">
            <div className="width_image_question">
              <Link
                to={"/users/" + this.props.answer.user.username}
                style={{ flex: 1 }}
              >
                <UserImage
                  user={this.props.answer.user}
                  bottomImage={false}
                  link={false}
                />
              </Link>
            </div>
            <div className="width_text_question ">
              <Link to={"/users/" + this.props.answer.user.username}>
                <label className="name">
                  {this.props.answer.user.first_name}{" "}
                  {this.props.answer.user.last_name}
                </label>
              </Link>
            </div>
          </div>
          <div className="row max_width_500 answer_text">
            {this.renderAnswer()}
          </div>
        </React.Fragment>
      );
    }
  }

  renderAnswer() {
    if (this.state.edit === true) {
      return (
        <EditAnswer
          answer={this.props.answer}
          updateAnswer={this.updateAnswer}
        />
      );
    }

    return (
      <label className="" style={{ display: "block" }}>
        {this.props.answer.name}
      </label>
    );
  }

  renderMedia() {
    if (this.props.answer.answer_type === "text") {
      return <div />;
    }
    return (
      <div className="max_width_500 answer_text answer_image">
        <ListMedia answer={this.props.answer} row={true} />
      </div>
    );
  }

  editQuestion = e => {
    const edit = !this.state.edit;
    this.setState({ edit });
  };

  updateAnswer = answer => {
    this.setState({ edit: false });
    this.props.updateAnswer(answer);
  };

  handleChangeComment = event => {};
}

export default ListAnswerRow;



// WEBPACK FOOTER //
// ./src/components/list/interface/list_answer_row.jsx